import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgTriangleDown = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M4.26666 6.40002H11.7333L8 11.2L4.26666 6.40002Z" />
  </svg>
)
const ForwardRef = forwardRef(SvgTriangleDown)
const IconSvgTriangleDown = createIcon(ForwardRef, 'SvgTriangleDown')
export default IconSvgTriangleDown
